import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddLrComponent } from "./add-lr/add-lr.component";
import { DetailLrComponent } from "./detail-lr/detail-lr.component";
import { EditLrComponent } from "./edit-lr/edit-lr.component";
import { LRListComponent } from "./lr-list/lr-list.component";
import { ViewLrComponent } from "./view-lr/view-lr.component";
import { InvoiceListComponent } from "./invoice-list/invoice-list.component";
import { NewInvoiceComponent } from "./new-invoice/new-invoice.component";
import { GstInvoiceComponent } from "./gst-invoice/gst-invoice.component";
import { ViewsTrackerComponent } from "./views-tracker/views-tracker.component";
import { ViewInvoiceComponent } from "./view-invoice/view-invoice.component";
import { TrackerModuleComponent } from "./tracker-module/tracker-module.component";
import { AddLrModuleComponent } from "./add-lr-module/add-lr-module.component";
import { EditTrackerComponent } from "./edit-tracker/edit-tracker.component";
import { DetailTrackerComponent } from "./detail-tracker/detail-tracker.component";
import { TrackerInvoiceListComponent } from "./tracker-invoice-list/tracker-invoice-list.component";
import { ViewTrackerInvoiceComponent } from "./view-tracker-invoice/view-tracker-invoice.component";
// import { UsersListComponent } from './users-list/users-list.component';
// import { AddUserComponent } from './add-user/add-user.component';
// import { EditUserComponent } from './edit-user/edit-user.component';

const routes: Routes = [
  {
    path: "",
    component: LRListComponent,
  },
  {
    path: "add-lr/:id",
    component: AddLrComponent,
  },
  {
    path: "view-tracker",
    component: ViewsTrackerComponent,
  },

  {
    path: "view-invoice",
    component: InvoiceListComponent,
  },
  {
    path: "tracker-invoice/view/:id",
    component: ViewTrackerInvoiceComponent,
  },
  {
    path: "view-tracker-invoice",
    component: TrackerInvoiceListComponent,
  },
  {
    path: "view-tripID",
    component: ViewInvoiceComponent,
  },
  {
    path: "edit-lr/:id",
    component: EditLrComponent,
  },
  {
    path: "edit-tracker/:id",
    component: EditTrackerComponent,
  },
  {
    path: "detail-lr/:id",
    component: DetailLrComponent,
  },
  {
    path: "detail-tracker/:id",
    component: DetailTrackerComponent,
  },
  {
    path: "view-lr/:id",
    component: ViewLrComponent,
  },
  {
    path: "invoice/:id",
    component: NewInvoiceComponent,
  },
  {
    path: "gst-invoice/:id",
    component: GstInvoiceComponent,
  },
  {
    path: "add-tracker/:id",
    component: TrackerModuleComponent,
  },
  {
    path: "add-lr-module/:id",
    component: AddLrModuleComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LrManagementRoutingModule {}
